module.exports = __webpack_public_path__ + "static/media/news3.7088911b.jpg";